import palette from 'theme/palette'

import { GAP } from 'helpers/reports/constants'

const drawProgressBar = (pdf, x, y, width, height, percentage, color) => {
  const validPercentage = percentage || 0
  const barFillWidth = width * (validPercentage / 100)

  pdf.setFillColor(palette.secondary.light)
  pdf.roundedRect(x, y, width, height, 5, 5, 'F')

  pdf.setFillColor(color)
  pdf.roundedRect(x, y, barFillWidth, height, 5, 5, 'F')
}

const progressBar = (pdf, title, data, startY) => {
  let currentY = startY || GAP
  const pageMargin = 49
  const pageWidth = pdf.internal.pageSize.getWidth()
  const usableWidth = pageWidth - pageMargin * 2
  const barHeight = 8
  const rowGap = 15

  pdf.setFontSize(13)
  pdf.setFont('Roboto-Bold')
  pdf.setFillColor(palette.primary.main)
  pdf.rect(pageMargin, currentY, usableWidth, 25, 'F')
  pdf.setTextColor(palette.white)
  pdf.text(title, pageMargin + 10, currentY + 25 / 2 + 4)
  currentY += 25 + 15

  data.forEach((item) => {
    pdf.setFontSize(11)
    pdf.setFont('Roboto-Regular')
    pdf.setTextColor(palette.primary.main)

    pdf.text(item.name, pageMargin, currentY)

    let displayText
    if (item.fractionText) {
      displayText = item.fractionText
    } else {
      displayText = `${item.percentage}%`
    }

    const textWidth = pdf.getStringUnitWidth(displayText) * pdf.getFontSize()
    pdf.text(displayText, pageWidth - pageMargin - textWidth, currentY)

    currentY += 4

    drawProgressBar(
      pdf,
      pageMargin,
      currentY,
      usableWidth,
      barHeight,
      item.percentage,
      palette.primary.main,
    )

    currentY += barHeight + rowGap
  })

  return currentY
}

export default progressBar
